export default __webpack_public_path__ + "static/media/netlify.552b42a5.jpg";